export enum TipoSolapaAutorizacion {
    Pendientes,
    Historial
}